export default {
    homepageLink: "Strona główna",
    cashbackLink: "Cashback",
    offersLink: "Okazje",
    eKarty: "eKarty",
    flyersLink: "Gazetki",
    blogLink: "Blog",
    pluginLink: "Wtyczka",
    pluginMsg: "Nowe",
    mgmLink: "Polecaj i zarabiaj",
    shoppingCenterLink: "Galerie",
    favoritesLink: "Ulubione",
};
